"use client";

import ProfileTooltip from "@/modules/profile/components/tooltip";
import { useAuth } from "@/providers/auth-provider";
import { useStore } from "@/providers/global-store-provider";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";
import SignupButton from "./signup-button";

const OnlineUsers = () => {
	const { isLoggedIn } = useAuth();
	const { onlineUsers } = useStore();
	const { isLoading, isError, users } = onlineUsers;

	const noOnlineUsers = users.length === 0;

	if (isLoading) {
		return <Skeleton count={1} className="h-40 w-full rounded-lg" />;
	}

	// Hide the component if there are no users or if there is an error
	if (noOnlineUsers || isError) {
		return <></>;
	}

	return (
		<div className="relative rounded-lg bg-white p-4 shadow">
			<div className="mb-4 flex items-center justify-between border-b pb-2">
				<h4 className="text-sm font-bold uppercase text-brand-primary">Who is Online</h4>

				{!isLoggedIn && <SignupButton size="sm" />}
			</div>

			<div className="mt-2 grid grid-cols-2 gap-4 lg:grid-cols-4">
				{users.map((user) => (
					<Link key={user.username} href={`/user/${user.username}`}>
						<div key={user.username} className="flex flex-col gap-1 text-center">
							<ProfileTooltip
								title={user.name}
								image={user.image}
								username={user.username}
								isFounder={user.isFounder}
								isVerified={user.isVerified}
								description={`${user.jobTitle || user.howDoYouIdentifyYourself || "-"} | ${
									user.company || "-"
								}`}
							/>
						</div>
					</Link>
				))}
			</div>
		</div>
	);
};

export default OnlineUsers;
